(function($) {
  $.localeSwitcher = function(el, options) {
    var defaults = {};

    var plugin = this;

    plugin.settings = {};

    var init = function() {
      plugin.settings = $.extend({}, defaults, options);
      plugin.el = el;
      plugin.$el = $(el);

      plugin.current = getCurrent();
      plugin.$languages = getLanguages();
      plugin.$list = buildList();
      plugin.$trigger = buildTrigger();
      hideSelect();
      appendSwitcher();
    };

    var getCurrent = function() {
      var selected = plugin.$el.find(':selected'),
        current;
      if (selected.length > 0) current = [selected.text(), selected.val()];
      return current;
    };

    var getLanguages = function() {
      var l = [];
      plugin.$el.find('option').each(function(i, language) {
        language = $(language);
        let value = language.attr('value');
        if (value != '') l.push([language.text(), language.attr('value')]);
      });
      return l;
    };

    var hideSelect = function() {
      plugin.$el.css({
        display: 'none',
      });
    };

    var buildList = function() {
      var $list = $('<ul />')
          .hide()
          .addClass('list'),
        path = plugin.$el.closest('form').attr('action'),
        $li,
        $a;
      $(plugin.$languages).each(function(i, language) {
        $a = $('<a />', { href: path + '?utf8=✓&locale=' + language[1] })
          .addClass('language ' + language[1])
          .html(language[0])
          .click(changeHandler);
        $li = $('<li />').append($a);
        $list.append($li);
      });
      $a = $('<a />', { href: path + '?utf8=✓&locale=' })
        .addClass('language remove')
        .html('default')
        .click(changeHandler);
      $li = $('<li />').append($a);
      $list.append($li);
      return $list;
    };

    var buildTrigger = function() {
      var $trigger = $('<a />', { href: '#locale' })
        .addClass('trigger')
        .click(triggerHandler)
        .text(plugin.current ? plugin.current[0] : 'Language');
      var $icon = "<span class='icon icon_map'></span>";
      $trigger.prepend($icon);
      return $trigger;
    };

    var appendSwitcher = function() {
      plugin.$list.insertAfter(plugin.$el);
      plugin.$trigger.insertAfter(plugin.$el);
      plugin.$el.closest('form').addClass('wgt');
    };

    // behavior

    var toggle = function() {
      plugin.$list.toggle();
      plugin.$trigger.toggleClass('open');
    };

    // handlers

    var triggerHandler = function(e) {
      e.preventDefault();
      toggle();
      return false;
    };

    var changeHandler = function() {};

    init();
  };
})(jQuery);
